import { GameSessionStatus } from '../../../assets/enums/game-session.enum.ts';
import { type ChallengeConfig } from '../../challenge-configs-api.ts';
import { type CourseListItem } from '../../courses-api.ts';
import type { Nullable } from '../../types.ts';
import { type PerformanceDashboardParams } from '../performance-api.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';

export const isCompleted = (session: SessionsServiceSession) =>
  session.status === GameSessionStatus.Completed || session.status === GameSessionStatus.PaidOut;

const getScopeCourseIds = (
  params: PerformanceDashboardParams,
  courses: CourseListItem[],
  regionCourses: CourseListItem[] | undefined
): Nullable<Set<string>> => {
  const scopes: Set<string>[] = [];

  if (regionCourses) {
    scopes.push(new Set(regionCourses.map((course) => course.id)));
  }
  if (params.partner_id) {
    scopes.push(
      new Set(
        courses.filter((course) => course.partner.id === params.partner_id).map(({ id }) => id)
      )
    );
  }
  if (params.course_id) {
    scopes.push(new Set([params.course_id]));
  }

  if (!scopes.length) return null;

  const [first, ...rest] = scopes;
  return new Set([...first].filter((id) => rest.every((scope) => scope.has(id))));
};

export const filterSessionsInScope = (
  sessions: SessionsServiceSession[],
  params: PerformanceDashboardParams,
  courses: CourseListItem[],
  regionCourses: CourseListItem[] | undefined
) => {
  const scope = getScopeCourseIds(params, courses, regionCourses);

  return sessions.filter(
    (session) =>
      !session.is_demo &&
      (scope === null || (session.course_id !== null && scope.has(session.course_id)))
  );
};

export const getGameName = (
  session: SessionsServiceSession,
  configsById: Map<number, ChallengeConfig>
) =>
  configsById.get(session.challenge_config_id)?.display_name ??
  session.challenge_config?.display_name ??
  `Game #${session.challenge_config_id}`;
